import { createAction } from 'typesafe-actions';
import { MainResourceHandler, RegisterPayload } from './types';

export function createRegisterAction<TItemKey, TItemSummary, TItemBody>(
  displayName: string,
) {
  const register = createAction(`@${displayName}/register`)<RegisterPayload>();

  const registerHandler: MainResourceHandler<
    TItemKey,
    TItemSummary,
    TItemBody,
    typeof register
  > = (state, action) => {
    return {
      ...state,
      requestBodyFragments: [
        ...state.requestBodyFragments,
        action.payload.fragment,
      ],
      overrides: action.payload.overrides
        ? [...state.overrides, action.payload.overrides]
        : state.overrides,
      patchData: undefined,
      error: undefined,
    };
  };

  return {
    register,
    registerHandler,
  };
}
